import './sections.css';

export default function Contact() {
    return (
        <>
            <div className='contact-page'></div>
        </>
    )
}